// John Eldhose 20200609
import React, { Component } from 'react';
import { Button, CircularProgress, Grid, MenuItem, TextField, Typography } from '@material-ui/core';
import { Business, ChevronRight, QuestionAnswer, Settings, Title } from '@material-ui/icons';
import { resetLoginPage } from '../lib/LoginPage';
import ProfileAddress from '../lib/ProfileAddress';
import industries from '../lib/industries';
import ShowStatus from '../lib/ShowStatus';
import { contactSales } from '../../Api/contactSales';

class Contact extends Component {

  state = {
    Question: '',
    Industry: '',
    JobTitle: '',
    ContactPreference: '',
    profile: null,
    address: null,
    pageStatus: 0
  }
  componentWillMount() {
    resetLoginPage();
  }
  handleUserInput = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  }
  handleContact = (p, a, b) => {
    this.setState({ profile: p, address: a });
    var s = this.state;
    var data = {
      Question: s.Question, Industry: s.Industry, JobTitle: s.JobTitle, ContactPreference: s.ContactPreference,
      CompanyDescription: p.CompanyDescription, FirstName: p.FirstName, LastName: p.LastName, email: p.email, phone: p.phone,
      ADDRESS1: a.ADDRESS1, CITY: a.CITY, STATE: a.STATE, POSTALCODE: a.POSTALCODE, COUNTRY: a.COUNTRY
    };
    contactSales(data)
      .then((con) => {
        this.setState({
          pageStatus: ((con['status'] === 'true') ? con['send'] : 2)
        });
      })
      .catch((err) => { console.log(err); })
  }

  render() {
    if (this.state.pageStatus === 1) {
      if(this.state.profile === null || this.state.address === null)
        return (
          <ProfileAddress
            Back={() => this.setState({ address: null, pageStatus: 0 })}
            Continue={this.handleContact}
            NoBillTo={true}
          />
        );
      else
        return <CircularProgress />;
    }

    else if(this.state.pageStatus === 2)
      return <ShowStatus status='failed' />;
    else if(this.state.pageStatus === 3)
      return <ShowStatus status='thankyou' />;
    else
      return (
        <div>
          <Typography variant='display1'>
            <font color='#385687'>Contact Sales</font>
          </Typography>
          <p />
          <Typography variant='title'>How can we help you?</Typography>
          <p />
          <div style={{ border: '1px solid silver' }}>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item>
                <QuestionAnswer className='IconProp' />
              </Grid>
              <Grid item xs zeroMinWidth>
                <TextField
                  required
                  fullWidth
                  multiline
                  rows='3'
                  inputProps={{ maxLength: 499 }}
                  label='Request a Quote or Ask a Question'
                  name='Question'
                  value={this.state.Question}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </Grid>
            </Grid>
          </div>
          <p />
          <Typography variant='title'>Your Details</Typography>
          <p />
          <div style={{ border: '1px solid silver' }}>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item>
                <Business className='IconProp' />
              </Grid>
              <Grid item xs zeroMinWidth>
                <TextField
                  fullWidth
                  select
                  label='Industry'
                  name='Industry'
                  value={this.state.Industry}
                  onChange={(event) => this.handleUserInput(event)}
                >
                  {industries.map(industry => (
                    <MenuItem key={industry} value={industry}>
                      {industry}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
          </div>
          <p />
          <div style={{ border: '1px solid silver' }}>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item>
                <Title className='IconProp' />
              </Grid>
              <Grid item xs zeroMinWidth>
                <TextField
                  fullWidth
                  label='Job Title'
                  name='JobTitle'
                  value={this.state.JobTitle}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </Grid>
            </Grid>
          </div>
          <p />
          <div style={{ border: '1px solid silver' }}>
            <Grid container spacing={8} alignItems="flex-end">
              <Grid item>
                <Settings className='IconProp' />
              </Grid>
              <Grid item xs zeroMinWidth>
                <TextField
                  fullWidth
                  select
                  label='Contact Preference'
                  name='ContactPreference'
                  value={this.state.ContactPreference}
                  onChange={(event) => this.handleUserInput(event)}
                >
                  {['Email', 'Phone'].map(pref => (
                    <MenuItem key={pref} value={pref}>{pref}</MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
          </div>
          <p />
          <Grid container>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} />
            <Grid item
              xs={12} sm={12} md={6} lg={6} xl={6}
              style={{ textAlign:'right' }}
            >
              <Button
                variant='raised'
                color='primary'
                style={{ textTransform: 'none' }}
                onClick={() => this.setState({ pageStatus: 1 })}
                disabled={this.state.Question === ''}
              >
                Continue &nbsp; <ChevronRight />
              </Button>
            </Grid>
          </Grid>
        </div>
      );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/home/Contact.js